import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.title,
    breakpoints: _ctx.dialogDescriptor.dialog.breakpoints,
    style: _ctx.dialogDescriptor.dialog.style,
    visible: _ctx.dialogVisible,
    modal: true,
    closable: false,
    class: "p-fluid kn-dialog--toolbar--primary"
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeDialog,
        class: "kn-button kn-button--primary"
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createTextVNode(" " + _toDisplayString(_ctx.message) + " ", 1)
    ]),
    _: 1
  }, 8, ["header", "breakpoints", "style", "visible"]))
}